const productcomment = {
    add: 'productcomment/add-by-admin',
    getlist: 'productcomment/getlist-by-admin',
    update: 'productcomment/update',
    remove: 'productcomment/remove',
    get: 'productcomment/get',
}
export default productcomment
